@use "~theme/typography";

.container {
  width: 100%;
  margin: var(--mobile-gutter);
}

.section {
  margin: 10px 0;
}

.paddedCard {
  box-shadow: drop-shadow(0 2px 4px var(--gray-01));
  border-radius: 4px;
  padding: 12px;
}

.snackbarCard {
  box-shadow: drop-shadow(0 2px 4px var(--gray-01));
  border-radius: 4px;
  padding: 12px 12px 200px;
  position: relative;
}

.snackArea {
  position: absolute;
  bottom: 0;
  margin: 12px;
  width: 100%;
}

.snack {
  margin: 0 auto;
  width: 240px;
  text-align: center;
  background-color: var(--blue-02);
  color: var(--white);
  border-radius: 4px;
  padding: 12px;
  margin-top: 12px;
}

.colors {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, 100px);
}

.colors__swatch {
  height: 100px;
  width: 100px;
  box-shadow: 2px 2px 4px var(--gray-01);
}

.colors__label {
  @include typography.caption;
  margin: 4px 0 0;
}

.typography__heading1 {
  @include typography.heading1;
}

.typography__heading2 {
  @include typography.heading2;
}

.typography__heading3 {
  @include typography.heading3;
}

.typography__heading4 {
  @include typography.heading4;
}

.typography__heading5 {
  @include typography.heading5;
}

.typography__button {
  @include typography.button;
}

.typography__buttonLarge {
  @include typography.button-large;
}

.typography__fieldLabel {
  @include typography.field-label;
}

.typography__body {
  @include typography.body;
}

.typography__bodySemibold {
  @include typography.body-semibold;
}

.typography__bodySemiboldLink {
  @include typography.body-semibold-link;
}

.typography__bodyLink {
  @include typography.body-link;
}

.typography__bodyLarge {
  @include typography.body-large;
}

.typography__bodyLargeLink {
  @include typography.body-large-link;
}

.typography__caption {
  @include typography.caption;
}

.typography__captionLink {
  @include typography.caption-link;
}

.typography__captionSemibold {
  @include typography.caption-semibold;
}

.typography__captionSemiboldLink {
  @include typography.caption-semibold-link;
}

.typography__smallText {
  @include typography.small-text;
}

.typography__smallTextLink {
  @include typography.small-text-link;
}
